import { PropsWithChildren } from 'react';
import styles from '~/components/@sibill-components/AutomaticallyAddSecondCompany/AddCompanyLayout.module.scss';
import AddCompanyStepper, {
  AddCompanySteps,
} from '~/components/@sibill-components/AutomaticallyAddSecondCompany/AddCompanyStepper';
import Icon from '~/components/data-display/Icon';
import { HStack } from '~/components/layout/Stack';
import Modal from '~/components/modals/Modal/Modal';
import ModalContent from '~/components/modals/Modal/ModalContent';
import ModalTitle from '~/components/modals/Modal/ModalTitle';
import Text from '~/components/typographies/Text';

export const AddCompanyLayout: React.FC<
  PropsWithChildren<{
    title: string;
    titleIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    step: AddCompanySteps;
  }>
> = ({ children, title, titleIcon, step }) => {
  return (
    <Modal className={styles.modal} isOpen>
      <ModalTitle className={styles.headerContainer}>
        <div className={styles.stepperContainer}>
          <AddCompanyStepper activeStep={step} />
        </div>
      </ModalTitle>
      <ModalContent className={styles.content}>
        <HStack gap={2} className={styles.titleBar} align="center">
          <div className={styles.iconContainer}>
            <Icon component={titleIcon} className={styles.icon} />
          </div>
          <Text variant="subtitle2">{title}</Text>
        </HStack>
        {children}
      </ModalContent>
    </Modal>
  );
};
